/**
 * Email normalisation helper — MV2-350.
 *
 * Cognito's user pool was created with `username_attributes=["email"]`
 * and the default case-sensitive `username_configuration`, and the
 * `case_sensitive` flag is **immutable** after pool creation. So a
 * user invited as `Mahendar@RENEWABLEBOT.com` cannot sign in with the
 * lowercase form — Cognito's email-as-username lookup is exact-case.
 *
 * Fix: lowercase + trim at every UI form boundary that hands an
 * email to either Amplify (login) or our backend (forgot-password,
 * invite, cross-client invite). The backend has a mirror helper at
 * `app/core/email.py::normalize_email` and a one-shot
 * `scripts/lowercase_emails.py` to canonicalise legacy mixed-case
 * rows.
 *
 * Keep this helper pure + idempotent. Never put it inside `useMemo`
 * etc. — it's cheap and being a top-level call lets callers chain
 * `?? ""` or fold it into one-liners.
 */
export function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}
